
import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgPneumatics from '../../../assets/Branch/Pneumatics.jpg'
import imgHANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC from '../../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC.webp';
import imgkragujevac1 from '../../../assets/Branch/kragujevac/kragujevac1.jpg';
import imgkragujevac2 from '../../../assets/Branch/kragujevac/kragujevac2.jpg';
import imgkragujevac3 from '../../../assets/Branch/kragujevac/kragujevac3.jpg';
import imgkragujevac4 from '../../../assets/Branch/kragujevac/kragujevac4.jpg';
import imgkragujevac5 from '../../../assets/Branch/kragujevac/kragujevac5.jpg';



const Branch2 = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [
        {
            image: imgkragujevac1,
        },
        {
            image: imgkragujevac2,
        },
        {
            image: imgkragujevac3,
        },
        {
            image: imgkragujevac4,
        },
        {
            image: imgkragujevac5,
        },

    ]

    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC} title={"Welcome to HANSA-FLEX Kragujevac"} paragraph={"Founded in 2012, on the very entrance to the city, right accross the fair ground, HANSA-FLEX Kragujevac has quickly gained the reputation of someone who doesn’t only sell elements and parts for hydraulics and pneumatics but provides complete solutions. That was recognized very quickly by many clients, not only big ones (Siemens, RAPP, FIAT...) but smaller ones also, construction companies, repair shops, washing shops, transporters etc. Beside Kragujevac, the branch covers the large region from Kruševac and Paraćin from the East, to Smederevska Palanka and Aranđelovac on the North and all the way to the western border toward BiH, southern toward Montenegro and to the administrative line to Kosovo."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />


            <ThreeDImageCarousel items={carouselData} />


            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>



        </div>
    )
}

export default Branch2